<app-top-bar></app-top-bar>

<div>
  <router-outlet></router-outlet>
</div>